export function appendQueryParam(url: string, key: string, value: string): string {
  const hashIndex = url.indexOf('#');
  const [base, fragment] = hashIndex >= 0 ? [url.slice(0, hashIndex), url.slice(hashIndex)] : [url, ''];
  const separator = base.includes('?') ? '&' : '?';
  return `${base}${separator}${key}=${value}${fragment}`;
}
